import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useOptOutSMSRequest } from '../modules/datastores/useWaitViaSMS';
import { useLocation, useSearch } from 'react-location';
import { uiStore } from '../modules/datastores/useUiStore';
import { SurvivorsConversationStore } from '../modules/datastores/useGetSurvivorsConversation';

const WaitViaSMSRedirect = () => {
  const query = useSearch();
  const messaging_service_key = query['messaging_service_key'] as string;
  const task_sid = query['task_sid'] as string;
  const { mutateAsync: mutateOptOutRequest } = useOptOutSMSRequest();
  const location = useLocation();

  const optOutRequest = () => {
    mutateOptOutRequest(
      { messaging_service_key, task_sid },
      {
        onSuccess: () => {
          location.history.replace('/');
          SurvivorsConversationStore.waitingViaSMS(false);
          
        },
        onError: (error: any) => {
          uiStore.setErrorMessage(error.errors?.toString());
        },
      }
    );
  };
  return (
    <Dialog open aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">You have successfully opted in to waiting via SMS, you can now close the browser.</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {' '}
          <Button className="button-primary mr-2 bg-color-change" onClick={() => optOutRequest()}>
            Opt Out Of Wait Via SMS
          </Button>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default WaitViaSMSRedirect;
